import manufacturer from '@/services/api/device-manufacturer';

export default {
  namespaced: true,
  state: {
    manufacturers: [],
  },
  getters: {
    manufacturers: state => state.manufacturers,
  },
  mutations: {
    setManufacturers: (state, payload) => {
      state.manufacturers = payload.data;
    },
  },
  actions: {
    getManufacturers (state, options = {}) {
      return new Promise((resolve, reject) => {
        manufacturer.getManufacturers(options)
          .then(({ data }) => {
            state.commit('setManufacturers', data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
  },
};
